import styled from 'styled-components';
import Dropdown from 'core/dropdown';
import { pxToRem } from 'utils/convert';

export const StyledCoreDropdown = styled(Dropdown)`
  &&& {
    &:hover,
    &:active {
      color: #2e8ece;
    }
  }
`;

export const CombinatorDropdownContainer = styled.div`
  &&& {
    width: 100%;
    > ${StyledCoreDropdown} {
      border: ${pxToRem(1)} solid rgba(34, 36, 38, 0.15); /** css file replacement */
      border-radius: ${pxToRem(3)};
      font-weight: bold; /** css file replacement */
      padding: ${pxToRem(5)} ${pxToRem(10)}; /** css file replacement */
      margin: 0 ${pxToRem(10)}; /** css file replacement */
      transition: border 0.2s;
      &&&&&:hover {
        border-color: rgba(34, 36, 38, 0.35);
      }
      &&&&&:focus {
        border-color: #96c8da;
      }
    }
  }
`;

export const TextContainer = styled.span`
  color: #616161; /** css file replacement */
  &:empty + ${StyledCoreDropdown} {
    margin-left: 0;
  }
`;
